import { React } from 'react';
import PropTypes from 'prop-types';
import {
  ValidatedTextInputV2,
  Spacer,
  AlertBase as Alert,
  Visible
} from '@tfecom-thermofisher/react-komodo-design';
import { injectIntl } from 'react-intl';

import { Button, Message } from 'src/core/components';
import { emailOnlyValidator } from 'src/validators';
import { Email } from 'src/models';
import messages from 'src/components/OligoDNA/messages';

import EmailsList from './components';
import { nonDuplicateEmailValidator } from './validators';
import './EmailForm.scss';

const EmailFormComponent = ({
  formState,
  onChangeInput,
  onSubmit,
  emails,
  setErrorEmails,
  errorEmails,
  handleEmailAddition,
  intl,
  handleDeleteEmail
}) => (
  <>
    <Visible when={emails?.length < Email.MAX_LENGTH}>
      <Spacer bottom={15} />
      <div className="flex-row justify-space-between email">
        <ValidatedTextInputV2
          label={(<Message message={messages.emailAddress} />)}
          required
          showOnlyOneError
          value={formState?.value}
          onChange={(value, e, canValidate, isValid) => onChangeInput(value, isValid)}
          validators={
            formState?.value ? [
              emailOnlyValidator(messages.invalidEmail),
              nonDuplicateEmailValidator(emails)
            ] : []
          }
          placeholder={intl.formatMessage(messages.emailPlaceholder)}
        />

        <div className="add">
          <Button
            type="primary"
            onClick={() => handleEmailAddition(formState)}
            label={messages.add}
            disabled={
              !formState.isValid ||
              nonDuplicateEmailValidator(emails).validator(formState?.value) === Email.ERROR
            }
          />
        </div>
      </div>
    </Visible>

    <Visible when={emails?.length > Email.MAX_LENGTH - 1}>
      <div className="max-email-msg">
        <Message message={{ ...messages.maxEmailCount, values: { maxValue: Email.MAX_LENGTH } }} />
      </div>
    </Visible>

    <Visible when={!!errorEmails}>
      <Alert
        white
        type="error"
        onClose={() => setErrorEmails(null)}
      >
        <Message message={errorEmails} />
      </Alert>
    </Visible>

    <EmailsList
      emails={emails}
      handleDeleteEmail={handleDeleteEmail}
      onSubmit={onSubmit}
    />
  </>
);

EmailFormComponent.propTypes = {
  formState: PropTypes.object.isRequired,
  errorEmails: PropTypes.object,
  onChangeInput: PropTypes.func.isRequired,
  emails: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  setErrorEmails: PropTypes.func.isRequired,
  handleEmailAddition: PropTypes.func.isRequired,
  intl: PropTypes.object,
  handleDeleteEmail: PropTypes.func.isRequired
};

export default injectIntl(EmailFormComponent);
